import React, { Fragment } from 'react';
import { toast } from 'react-toastify';

import {
  addToSessionStorageAsync,
  readFromSessionStorageAsync,
} from '../Services/Compare.service';
import {
  COMPARE_PRODUCT_LOADED,
  COMPARE_PRODUCT_REMOVED,
  COMPARE_PRODUCT_URL_UPDATED,
  PRODUCT_COMPARISON_LOAD_ERROR,
} from '../constants';
import { catchError } from './Error.action';

import { post } from '../Services/http';
import { translate } from '../Services/translation';

const PRODUCT_COMPARISON_MAX_ITEMS = 3;
const PRODUCT_COMPARISON = 'PRODUCT_COMPARISON_COLLECTION';
const PRODUCT_COMPARISON_URL = 'PRODUCT_COMPARISON_URL';
export const loadError = (error) => ({
  type: PRODUCT_COMPARISON_LOAD_ERROR,
  payload: {
    error,
  },
});

export const loadArticles = (articles, articleNumber) => (dispatch) => {
  const articleNumbers = articles.map((x) => x.articleNumber);
  return post('/api/compare/getProductDetails', { articleNumbers })
    .then((response) => response.json())
    .then(({ productDetails, comparePageUrl }) => {
      let _items = [];

      // get category for last added item
      const item = productDetails.find(
        (x) => x.articleNumber === articleNumber
      );
      const otherItems = productDetails.filter(
        (x) => x.articleNumber !== articleNumber
      );

      const hasAnyOtherCategory = otherItems.some(
        (x) =>
          x.mainCategory !== item.mainCategory ||
          x.isBaseProduct !== item.isBaseProduct
      );

      // if category anu of the items has different category remove them and update new state for current category
      _items = hasAnyOtherCategory ? [item] : [...productDetails];

      // save to store
      dispatch(loaded(_items));
      dispatch(loadedUrl(comparePageUrl));

      // save to session storage
      addToSessionStorageAsync(PRODUCT_COMPARISON, _items);
      addToSessionStorageAsync(PRODUCT_COMPARISON_URL, comparePageUrl);
    })
    .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loaded = (articles) => ({
  type: COMPARE_PRODUCT_LOADED,
  payload: {
    articles,
  },
});

export const loadedUrl = (comparePageUrl) => ({
  type: COMPARE_PRODUCT_URL_UPDATED,
  payload: {
    comparePageUrl,
  },
});

export const articleRemoved = (articleNumber) => ({
  type: COMPARE_PRODUCT_REMOVED,
  payload: {
    articleNumber,
  },
});

export const loadItems = () => (dispatch) => {
  return readFromSessionStorageAsync(PRODUCT_COMPARISON).then(
    (articles = []) => {
      // prevent empty array
      const items = articles ?? [];

      dispatch(loaded(items));
    }
  );
};
export const loadCompareUrl = () => (dispatch) => {
  return readFromSessionStorageAsync(PRODUCT_COMPARISON_URL).then(
    (comparePageUrl = []) => {
      dispatch(loadedUrl(comparePageUrl));
    }
  );
};

export const addArticleItem = (article) => (dispatch, getState) => {
  const { articles } = getState().compare;

  const items = articles ?? [];

  if (maxProductReached(items.length)) return;

  const { articleNumber } = article;

  const _exists = items.some((a) => a.articleNumber === articleNumber);

  if (_exists) return;

  const _items = _exists ? items : [...items, article];

  dispatch(loadArticles(_items, articleNumber));
};

export const removeArticleItem = (articleNumber) => (dispatch) => {
  return readFromSessionStorageAsync(PRODUCT_COMPARISON).then(
    (articles = []) => {
      const items = articles ?? [];

      const _index = items.findIndex((a) => a.articleNumber === articleNumber);

      if (_index === -1) return;

      items.splice(_index, 1);

      dispatch(removeArticlesFromStore(items, articleNumber));
    }
  );
};

export const removeArticlesFromStore = (articles, articleNumber) => (
  dispatch
) => {
  return addToSessionStorageAsync(PRODUCT_COMPARISON, articles).then((a) => {
    dispatch(articleRemoved(articleNumber));
  });
};
const ToastContent = ({ header, description }) => (
  <Fragment>
    <h6 className="toastify__toast-title">{header}</h6>
    <p className="toastify__toast-description">{description}</p>
  </Fragment>
);

const notify = () =>
  toast.info(
    <ToastContent
      header={translate('productcompare.limitheader')}
      description={translate('productcompare.description')}
    />
  );

const maxProductReached = (length = 0) => {
  const max = length >= PRODUCT_COMPARISON_MAX_ITEMS;
  if (max) {
    notify();
  }

  return max;
};
